<template>
    <section class="profile-view">
        <HeaderComponent :title="'Perfil'" />
        <div class="profile-container">

            <div class="button-cont">
                <ButtonCenter :button="buttonEdit" style="width: 40%;" @click="buttonEdit.action && buttonEdit.action()" />
                <ButtonCenter v-if="isEditing" :button="buttonCancel" style="width: 40%;" @click="cancelEdit()" />
            </div>

            <div v-for="(section, key) in profileSections" :key="key">
                <h1>{{ section.title }}</h1>
                <div class="field-container" v-for="(field, fkey) in section.fields" :key="fkey" @click="openSelectList(field)">
                    <div class="field" v-text="field.display"></div>
                    <div class="fieldValue" :class="{ 'multiline': field.value.length > 20 }">
                        <template v-if="isEditing">
                            <input v-if="field.type != 'select'" class="edit-input" type="text" v-model="field.value" @input="field.value = formatValue(field.value, field.format)" />
                            <div v-else class="edit-input" > {{ field.value }}</div>
                        </template>
                        <template v-else>
                            {{ field.value }}
                        </template>
                    </div>
                </div>
                <template v-if="key === 0">
                    <div class="checkboxField space-botton" :class="{ 'disabled-click': !isEditing }" v-for="(check, ckey) in profileFields.checkboxes" :key="ckey">
                        <input type="checkbox" :id="check.id" :checked="check.value" @click="check.value = !check.value">
                        <label :for="check.id">{{ check.display }}</label>
                    </div>
                </template>
            </div>

            <SelectList></SelectList>
        </div>
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import SelectList from '@/components/bottom-popups/SelectList.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import { getConsumerDetails, updateProfile } from '@/components/controllers/ConsumerController.js'
import { format } from '@/components/controllers/FormatController.js'
import { getStates, getCities } from '@/components/controllers/RegisterController'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'ProfileView',
    components: {
        HeaderComponent,
        SelectList,
        ButtonCenter
    },
    data () {
        return {
            states: [],
            cities: []
        }
    },
    computed: {
        ...mapGetters(['profileFields', 'isEditing', 'buttonEdit', 'buttonCancel', 'getUfData']),
        profileSections () {
            return [
                {
                    title: 'Dados pessoais',
                    fields: this.profileFields.personalData
                },
                {
                    title: 'Endereço',
                    fields: this.profileFields.addressData
                }
            ]
        }
    },
    mounted () {
        this.stopEditing({ action: this.startEdit })
        getConsumerDetails()
    },
    methods: {
        ...mapActions(['showSelectList', 'startEditing', 'stopEditing', 'saveBackupData', 'restoreBackupData']),
        startEdit () {
            this.saveBackupData()
            this.startEditing({ action: this.confirmEdit })
        },
        confirmEdit () {
            this.stopEditing({ action: this.startEdit })
            updateProfile()
        },
        cancelEdit () {
            this.restoreBackupData()
            this.stopEditing({ action: this.startEdit })
        },
        async openSelectList (field) {
            if (this.isEditing && field.type === 'select') {
                if (field.display === 'UF') {
                    this.states = []
                    this.states = await getStates()
                    this.showSelectList({ title: 'UF', options: this.states, optionDisplay: 'NMESTADO', event: 'setUfData' })
                } else if (field.display === 'Município') {
                    this.cities = []
                    this.cities = await getCities(this.getUfData)
                    this.showSelectList({ title: 'Município', options: this.cities, optionDisplay: 'NMMUNICIPIO', event: 'setCityData' })
                }
            }
        },
        formatValue: function (value, formatString) {
            return format(value, formatString)
        }
    },
    directives: {
        myFocus: {
            mounted (el, binding) {
                if (binding.value) {
                    el.focus()
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.profile-container {
    position: relative;
    height: calc(100vh - 75px);
    margin-bottom: 20px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    .button-cont {
        display: flex;
    }

    .space-botton {
        margin-bottom: 20px;
    }

    .disabled-click {
        pointer-events: none;
    }

    h1 {
        font-size: 20px;
        font-weight: 600;
        color: var(--primaryColor);
        margin: 30px auto;
    }

    .field-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 20px;
        border-bottom: solid #BAB8B8 2px;

        .field {
            color: #818181;
            font-size: 16px;
            font-weight: 600;
            padding-bottom: 20px;
            max-width: 30%;
        }

        .fieldValue {
            margin-left: auto;
            margin-right: 5px;
            font-weight: 500;
            max-width: 40%;
        }

        .icon {
            margin-left: 15px;
            max-width: 30%;
        }

        .multiline {
            word-break: break-word; /* Quebra a palavra em várias linhas */
        }

        input.edit-input {
            border: none;
            outline: none;
            font-size: 16px;
            max-width: 100%;
            text-align: right;
            font-family: inherit;
        }
    }
}
</style>
